import StudentReadingRoom from "../../../components/sessions/StudentReadingRoom";
import { showCandidateSession } from "../../../api/endpoints/candidate/sessions";
import { indexCandidateNotes } from "../../../api/endpoints/candidate/notes";

export default function ReadingRoom() {
  return (
    <StudentReadingRoom
      getUserSession={showCandidateSession}
      indexNotes={indexCandidateNotes}
    />
  );
}
